'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _projects = require('helpers/projects');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var MediaListPopover = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, projectActions), null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(MediaListPopover, _Component);

  function MediaListPopover() {
    (0, _classCallCheck3.default)(this, MediaListPopover);
    return (0, _possibleConstructorReturn3.default)(this, (MediaListPopover.__proto__ || (0, _getPrototypeOf2.default)(MediaListPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(MediaListPopover, [{
    key: 'onDropError',
    value: function onDropError(error) {
      return _toastr2.default.error(error);
    }
  }, {
    key: 'getReplaceMediaFile',
    value: function getReplaceMediaFile(el) {
      if (el) {
        this.replaceMediaFile = el.getWrappedInstance().getWrappedInstance();
      }
    }
  }, {
    key: 'deleteMedia',
    value: function deleteMedia(media) {
      var _props = this.props,
          deleteMedia = _props.deleteMedia,
          projectId = _props.projectId,
          t = _props.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteMedia(projectId, media.id);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this file?'), toastrConfirmOptions);
    }
  }, {
    key: 'editMedia',
    value: function editMedia(reqField) {
      var mediaField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reqField;
      var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.popover.data;
      var _props2 = this.props,
          editMedia = _props2.editMedia,
          projectId = _props2.projectId,
          t = _props2.t;


      this.prompt.getWrappedInstance().show({
        title: t('Edit media'),
        value: media[mediaField],
        onOk: function onOk(val) {
          return editMedia(projectId, media.id, (0, _defineProperty3.default)({}, reqField, val));
        }
      });
    }
  }, {
    key: 'replaceMedia',
    value: function replaceMedia(media) {
      var _props3 = this.props,
          t = _props3.t,
          projectId = _props3.projectId;


      this.replaceMediaFile.show({
        title: t('Replace media file'),
        onOk: function onOk(val) {
          return console.log(val);
        },
        media: media,
        postParams: { projectId: projectId }
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(e, media) {
      this.popover.toggle(e, media);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props4 = this.props,
          t = _props4.t,
          projectType = _props4.projectType,
          projectId = _props4.projectId,
          hideReplaceFile = _props4.hideReplaceFile,
          hideDelete = _props4.hideDelete,
          hideIsrc = _props4.hideIsrc,
          hidePackId = _props4.hidePackId,
          isStandardMode = _props4.isStandardMode;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.PopoverMenu,
          { id: 'mediaListPopover', ref: function ref(el) {
              _this2.popover = el;
            } },
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.editMedia('fileName', 'filename');
              } },
            t('Edit File Name'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          !hidePackId && _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.editMedia('part');
              } },
            t('Edit Pack ID'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          !hideIsrc && _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.editMedia('isrc');
              } },
            t('Edit ISRC'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.editMedia('artist');
              } },
            t('Edit Artist'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          !hideReplaceFile && !isStandardMode && projectType !== _projects.projectTypes.video && _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.replaceMedia(_this2.popover.data);
              } },
            t('Replace Track'),
            _react2.default.createElement('i', { className: 'icon-upload' })
          ),
          !hideDelete && _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.deleteMedia(_this2.popover.data);
              } },
            t('Delete Track'),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        ),
        !hideReplaceFile && _react2.default.createElement(_components.ReplaceMediaFile, { ref: this.getReplaceMediaFile, projectId: projectId, projectType: projectType, onDropError: this.onDropError }),
        _react2.default.createElement(_components.Prompt, { ref: function ref(el) {
            return _this2.prompt = el;
          } })
      );
    }
  }]);
  return MediaListPopover;
}(_react.Component), _class3.propTypes = {
  deleteMedia: _propTypes2.default.func,
  editMedia: _propTypes2.default.func,
  hideDelete: _propTypes2.default.bool,
  hideIsrc: _propTypes2.default.bool,
  hidePackId: _propTypes2.default.bool,
  hideReplaceFile: _propTypes2.default.bool,
  isStandardMode: _propTypes2.default.bool,
  projectId: _propTypes2.default.number.isRequired,
  projectType: _propTypes2.default.string.isRequired,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onDropError', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onDropError'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'getReplaceMediaFile', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'getReplaceMediaFile'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = MediaListPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Project/MediaList/MediaListPopover.js
// module id = 2049
// module chunks = 1